// Tax States

export default {
  taxList: [],
  taxInfo: {},
  income: {}
}
